import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

const TenantInfo = () => {
  const [users, setUsers] = useState([]);
  const { user } = useAuth(); // get user from context

  const loadUsersDetails = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/tenancy-users`, {
        method: 'POST',
        headers: {'Content-Type' : 'application/json'},
        body: JSON.stringify({user_id: user.id})
      });
      const result = await response.json();
      
      if (response.ok) {
        setUsers(result);
      } else {
        console.error(result.error);
      }
    } catch (error) {
      console.error('Error: ', error);
    }
  };

  useEffect(() => {
    if (user && user.id) {
      loadUsersDetails();
    }
  }, [user]);

  return (
    <div>
      <h1>Tenant Information</h1>

      <ul>
        {users
          .filter(person => person.role == 'tenant')
          .map((tenant, index) => (
            <li key={index}>
              <strong>Name:</strong> {tenant.name}<br />
              <strong>Email:</strong> {tenant.email}<br />
              <strong>Phone:</strong> {tenant.phone}<br />
              <br />
            </li>
        ))}
      </ul>
    </div>
  );
};

export default TenantInfo;
